import "core-js/modules/es.array.push.js";
import request from "../../util/request";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Maxterm',
  data() {
    let validateQuestion_Name = (rule, value, callback) => {
      if (value === this.repeatName && this.dialogFormVisibleEdit === true) {
        callback();
      } else {
        request.get('/Maxterm/getByName', {
          params: {
            maxtermName: value
          }
        }).then(res => {
          if (res == null || res == '') {
            callback();
          } else {
            callback(new Error("名称重复，重新输入！"));
          }
        });
      }
    };
    return {
      templateId: this.$route.query.templateId,
      search: '',
      repeatName: '',
      //判断名字是否重复
      form: {
        maxtermType: 0,
        maxtermKind: 0,
        mark: 1
      },
      //大项明细表
      MaxDetails: {
        createBy: sessionStorage.getItem('userName'),
        createDate: new Date()
      },
      editform: {},
      dialogFormVisibleEdit: false,
      //修改弹窗
      dialogFormVisible: false,
      //添加大项模板弹窗
      dialogVisible: false,
      //查看详情弹窗
      theOne: {},
      //查看的单条数据
      //图片路径
      imgUrl: require('/src/assets/logo.png'),
      currentPage: 1,
      pageSize: 20,
      total: 10,
      small: "small",
      background: "background",
      prev: this.currentPage - 1,
      pager: this.currentPage,
      next: this.currentPage + 1,
      jumper: this.currentPage,
      ticket: [],
      //未分页的数据
      tableData: [],
      //已分页的数据
      reload: 0,
      //判断重新将currentPage 设置为 1； 0：currentPage=1
      varValue: "",
      //判断是否已经点击了模糊查询
      rules: {
        maxtermName: [
        // { pattern:/^([a-z0-9]([a-z0-9-.]*)[a-z0-9])$|^([a-z0-9])$/, message: '只能输入小写字母、数字、点号.和横线-并且点号 . 和横线 - 不能在开头或结尾', trigger: 'blur' },
        {
          required: true,
          min: 2,
          max: 50,
          message: '模板大项名不能为空,长度： 2 ~ 50',
          trigger: 'blur'
        }, {
          validator: validateQuestion_Name,
          required: true,
          message: '模板大项名重复，重新输入',
          trigger: 'blur'
        }],
        createBy: [{
          required: true,
          message: '请输入创建人',
          trigger: 'blur'
        }],
        createDate: [{
          required: true,
          message: '请输入创建时间',
          trigger: 'blur'
        }],
        maxtermNo: [{
          required: true,
          message: '请输入项目编码',
          trigger: 'blur'
        }],
        module: [{
          required: true,
          message: '请输入具体的模块名称',
          trigger: 'blur'
        }],
        maxtermSort: [{
          required: true,
          message: '请输入项目序号',
          trigger: 'blur'
        }]
      }
    };
  },
  created() {
    this.load();
  },
  methods: {
    qSearch() {
      if (this.search == null || this.search == "") {
        this.load();
      }
      request.get('/Maxterm/getByName', {
        params: {
          maxtermName: this.search
        }
      }).then(res => {
        console.log(res);
        this.tableData = res;
        this.total = this.tableData.length;
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    //添加按钮点击事件
    add() {
      this.dialogFormVisible = true;
    },
    //时间格式
    formatDate(value, fmt) {
      if (value == null || value == '') {
        return "";
      }
      let getDate = new Date(value);
      let o = {
        'M+': getDate.getMonth() + 1,
        'd+': getDate.getDate(),
        'h+': getDate.getHours(),
        'm+': getDate.getMinutes(),
        's+': getDate.getSeconds(),
        'q+': Math.floor((getDate.getMonth() + 3) / 3),
        'S': getDate.getMilliseconds()
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length));
      }
      for (let k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
        }
      }
      return fmt;
    },
    //页面初始化
    load() {
      console.log("查看一下id");
      console.log(this.templateId);
      request.post('/Maxterm/maxtermAll', this.templateId).then(res => {
        console.log(res);
        this.ticket = res;
        this.total = this.ticket.length;
        this.getPageInfo();
      });
    },
    //保持数据
    save(formName) {
      console.log(this.$refs[formName]);
      if (this.form.module == '' || this.form.module == null) {
        this.$alert('请输入具体的模块名称', '提示', {
          confirmButtonText: '确定'
        });
        return;
      }
      if (this.form.maxtermName == '' || this.form.maxtermName == null) {
        this.$alert('请输入检测模板大项名称', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            console.log(action);
          }
        });
        return;
      }
      if (this.form.maxtermNo == '' || this.form.maxtermNo == null) {
        this.$alert('请输入项目编码', '提示', {
          confirmButtonText: '确定'
        });
        return;
      }
      this.$refs[formName].validate(valid => {
        //valid是检验的结果,bool值 validator: validateSolution_Name,
        console.log("看看");
        console.log(this.templateId);
        this.form.templateId = this.templateId;
        if (valid) {
          this.form.createBy = sessionStorage.getItem('userName');
          this.form.createDate = new Date();
          request.post('/Maxterm/save', this.form).then(res => {
            console.log(res.code + res.mag + res.date + "save" + res);
            if (res == 1) {
              this.$message({
                message: "添加成功",
                type: "success"
              });
              this.load();
              this.dialogFormVisible = false;
              this.form = {};
              this.form.maxtermType = 0;
              this.form.maxtermKind = 0;
              this.form.mark = 0;
            } else {
              this.$message({
                message: "添加失败",
                type: "error"
              });
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //修改数据
    edit(editform) {
      console.log(editform);
      if (this.editform.module == '' || this.editform.module == null) {
        this.$alert('请输入具体的模块名称', '提示', {
          confirmButtonText: '确定'
        });
        return;
      }
      if (this.editform.maxtermName == '' || this.editform.maxtermName == null) {
        this.$alert('请输入检测模板大项名称', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            console.log(action);
          }
        });
        return;
      }
      if (this.editform.maxtermNo == '' || this.editform.maxtermNo == null) {
        this.$alert('请输入项目编码', '提示', {
          confirmButtonText: '确定'
        });
        return;
      }
      this.editform.updateBy = sessionStorage.getItem('userName');
      this.editform.updateDate = new Date();
      this.editform.maxtermName = this.editform.maxtermName.replace(/\s*/g, '');
      console.log(this.editform);
      request.post('/Maxterm/update', this.editform).then(res => {
        if (res == 1) {
          this.$message({
            message: "编辑成功",
            type: "success"
          });
          this.load();
          this.dialogFormVisibleEdit = false;
        } else {
          this.$message({
            message: "编辑失败",
            type: "error"
          });
        }
      });
    },
    //查看大项详情
    toDetail(row) {
      console.log("详情查看");
      console.log(row);
      this.theOne = row;
      this.dialogVisible = true;
    },
    //跳转到模板细项页面
    toScene(maxtermId) {
      this.$router.push({
        path: 'Scene',
        query: {
          maxtermId: maxtermId
        }
      });
    },
    //跳转到要求页面
    toAsk(maxtermId) {
      this.$router.push({
        path: 'Ask',
        query: {
          maxtermId: maxtermId
        }
      });
    },
    //修改按钮点击事件
    update(row) {
      console.log(row);
      request.post('/Maxterm/findByMid', row.maxtermId).then(res => {
        this.dialogFormVisibleEdit = true;
        console.log(res);
        this.editform = res[0];
        this.editform.maxtermKind = parseInt(res[0].maxtermKind);
      });
    },
    deleteOne(maxtermId) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request.post('/Maxterm/delete', maxtermId).then(res => {
          if (res > 0) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          }
          if (res == -1) {
            this.$alert('该检测大项模板下还有内容', '提示', {
              confirmButtonText: '确定'
            });
          }
          if (res == -2) {
            this.$message({
              type: 'info',
              message: '删除失败'
            });
          }
          this.load();
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //分页三件套
    // 获取当前页的数据信息
    getPageInfo() {
      //清空pageTicket中的数据
      this.tableData = [];
      // 获取当前页的数据
      for (let i = (this.currentPage - 1) * this.pageSize; i < this.total; i++) {
        //把遍历的数据添加到pageTicket里面
        this.tableData.push(this.ticket[i]);
        //判断是否达到一页的要求
        if (this.tableData.length === this.pageSize) break;
      }
    },
    handleSizeChange(pageSize) {
      //修改当前每页的数据行数
      this.pageSize = pageSize;
      //数据重新分页
      this.getPageInfo();
    },
    handleCurrentChange(pageNum) {
      //修改当前的页码
      this.currentPage = pageNum;
      //数据重新分页
      this.getPageInfo();
    },
    tableRowClassName({
      rowIndex
    }) {
      for (var i = 0; i < this.tableData.length; i++) {
        if (rowIndex === i) {
          return 'success-row';
        }
      }
      return '';
    }
  }
};